"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable */
var classReducer = function classReducer(ClassDef) {
  var persist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  persist = persist && new ClassDef();
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var reducer = (persist || new ClassDef())[action.type];
    return reducer && reducer(state, action) || state;
  };
};
var _default = exports["default"] = classReducer;
//# sourceMappingURL=_classReducer.js.map